<ll-titulo>{{ "puntaje_core.carreras.carrera_sede.titulo" | t }}</ll-titulo>

<carrera-sede [carreraSedeId]="carreraSedeId"></carrera-sede>
